import { History } from "history";
import { Dispatch } from "redux";
import { Api } from "../../api";
import { Step } from "../../types/Step";
import { TariffaSingola } from "../../types/TariffaSingola";
import { FAILURE, REQUEST, SUCCESS } from "../../utils/actionsTypes";
import { getPath } from "../../utils/getPath";
import { IAction, IStore } from "../store";
import { backStepEngineState, backToStepEngineState, nextStepEngineState, updateEngineState } from "./engine";
import { EngineState } from "./engine.types";
import { LineaEnum, Configuratore } from "../../types/Configuratore";

export enum EngineActionType {
  LOAD_MOV = "engine/LOAD_MOV",
  LOAD_MOV_VIV = "engine/LOAD_MOV_VIV",
  LOAD_MOV_VIV_LAV = "engine/LOAD_MOV_VIV_LAV",
  SET_WHAT = "engine/SET_WHAT",
  SET_FAMIGLIA = "engine/SET_FAMIGLIA",
  SELECT = "engine/SELECT",
  BACK = "engine/BACK",
  BACK_TO_STEP = "engine/BACK_TO_STEP",
}

export const engineInitialState: EngineState = {
  step: Step.COSA,
  prevSteps: [],
  loadingMov: true,
  loadingMovViv: true,
  loadingMovVivLav: true,
  loading: true,
  loadingMovError: undefined,
  loadingMovVivError: undefined,
  loadingMovVivLavError: undefined,
  selections: {
    famiglia: true,
    vivere: undefined,
    muoversi: undefined,
    dipendente: undefined,
    deciditu: true,
    prezzo: undefined,
  },
  tariffe: [],
  tariffeMultiple: {},
  completeMov: false,
  completeMovViv: false,
  completeMovVivLav: false,
};

export const engineReducer = (state: EngineState = engineInitialState, action: IAction): EngineState => {
  let selections: Partial<TariffaSingola>;
  switch (action.type) {
    case REQUEST(EngineActionType.LOAD_MOV):
      return {
        ...state,
        loadingMov: true,
        loadingMovError: undefined,
      };
    case REQUEST(EngineActionType.LOAD_MOV_VIV):
      return {
        ...state,
        loadingMovViv: true,
        loadingMovVivError: undefined,
      };
    case REQUEST(EngineActionType.LOAD_MOV_VIV_LAV):
      return {
        ...state,
        loadingMovVivLav: true,
        loadingMovVivLavError: undefined,
      };

    case SUCCESS(EngineActionType.LOAD_MOV):
      return {
        ...state,
        completeMov: true, // First step is always complete (no checkbox/radio...)
        loadingMov: false,
        tariffeMultiple: { ...state.tariffeMultiple, mov: action.payload.premioAnnuo },
      };
    case SUCCESS(EngineActionType.LOAD_MOV_VIV):
      return {
        ...state,
        completeMovViv: true, // First step is always complete (no checkbox/radio...)
        loadingMovViv: false,
        tariffeMultiple: { ...state.tariffeMultiple, movViv: action.payload.premioAnnuo },
      };
    case SUCCESS(EngineActionType.LOAD_MOV_VIV_LAV):
      return {
        ...state,
        completeMovVivLav: true, // First step is always complete (no checkbox/radio...)
        loadingMovVivLav: false,
        tariffeMultiple: { ...state.tariffeMultiple, movVivLav: action.payload.premioAnnuo },
      };

    case FAILURE(EngineActionType.LOAD_MOV):
      return {
        ...state,
        loadingMov: false,
        loadingMovError: action.payload,
      };
    case FAILURE(EngineActionType.LOAD_MOV_VIV):
      return {
        ...state,
        loadingMovViv: false,
        loadingMovVivError: action.payload,
      };
    case FAILURE(EngineActionType.LOAD_MOV_VIV_LAV):
      return {
        ...state,
        loadingMovVivLav: false,
        loadingMovVivLavError: action.payload,
      };

    case EngineActionType.SET_WHAT:
      selections = {
        ...state.selections,
        vivere: action.payload.vivere,
        muoversi: action.payload.muoversi,
        dipendente: action.payload.dipendente,
        prezzo: action.payload.prezzo,
      };
      // Se tutti i checkbox sono false equivale a nessuna selezione fatta!
      if (selections.vivere === false && selections.muoversi === false && selections.dipendente === false) {
        selections.vivere = undefined;
        selections.muoversi = undefined;
        selections.dipendente = undefined;
      }
      return nextStepEngineState(state, selections);

    case EngineActionType.SET_FAMIGLIA:
      selections = { ...state.selections, famiglia: action.payload };
      return updateEngineState(state, selections);

    case EngineActionType.SELECT:
      return nextStepEngineState(state, state.selections);

    case EngineActionType.BACK:
      return backStepEngineState(state);

    case EngineActionType.BACK_TO_STEP:
      return backToStepEngineState(state, action.payload);

    default:
      return state;
  }
};

export const setFamiglia = (checked?: boolean) => ({ type: EngineActionType.SET_FAMIGLIA, payload: checked });

// Thunk
export const loadTariffe =
  () =>
  (dispatch: Dispatch, getState: () => IStore): void => {
    const state = getState();
    const intermediario = state.intermediario.data;
    if (intermediario) {
      dispatch({ type: REQUEST(EngineActionType.LOAD_MOV) });
      const prevMob: Configuratore = {
        olsFp: {
          lineaProdotto: LineaEnum.mob,
          nucleoFamigliare: true,
        },
        frazionamento: 1,
        tokenIntermediario: intermediario.tokenIntermediario,
      };
      Api.priceCalculation(prevMob)
        .then((data) => {
          dispatch({ type: SUCCESS(EngineActionType.LOAD_MOV), payload: data });
        })
        .catch((error) => {
          dispatch({ type: FAILURE(EngineActionType.LOAD_MOV), payload: error.message });
        });

      dispatch({ type: REQUEST(EngineActionType.LOAD_MOV_VIV) });
      const prevMobViv: Configuratore = {
        olsFp: {
          lineaProdotto: LineaEnum.mobViv,
          nucleoFamigliare: true,
        },
        frazionamento: 1,
        tokenIntermediario: intermediario.tokenIntermediario,
      };
      Api.priceCalculation(prevMobViv)
        .then((data) => {
          dispatch({ type: SUCCESS(EngineActionType.LOAD_MOV_VIV), payload: data });
        })
        .catch((error) => {
          dispatch({ type: FAILURE(EngineActionType.LOAD_MOV_VIV), payload: error.message });
        });

      dispatch({ type: REQUEST(EngineActionType.LOAD_MOV_VIV_LAV) });
      const prevMobVivLav: Configuratore = {
        olsFp: {
          lineaProdotto: LineaEnum.mobVivLav,
          nucleoFamigliare: true,
        },
        frazionamento: 1,
        tokenIntermediario: intermediario.tokenIntermediario,
      };
      Api.priceCalculation(prevMobVivLav)
        .then((data) => {
          dispatch({ type: SUCCESS(EngineActionType.LOAD_MOV_VIV_LAV), payload: data });
        })
        .catch((error) => {
          dispatch({ type: FAILURE(EngineActionType.LOAD_MOV_VIV_LAV), payload: error.message });
        });
    }
  };

export const selectWhat =
  (vivere: boolean, muoversi: boolean, dipendente: boolean, prezzo: number, history: History) =>
  (dispatch: Dispatch, getState: () => IStore): void => {
    const state = getState();
    const step = state.engine.step;
    const intermediario = state.intermediario.id;
    dispatch({ type: EngineActionType.SET_WHAT, payload: { vivere, muoversi, dipendente, prezzo } });

    const newStep = getState().engine.step;
    if (newStep !== step) {
      history.replace(getPath(newStep, intermediario));
    }
  };

export const forward =
  (history: History) =>
  (dispatch: Dispatch, getState: () => IStore): void => {
    const state = getState();
    const step = state.engine.step;
    const intermediario = state.intermediario.id;
    dispatch({ type: EngineActionType.SELECT });
    const newStep = getState().engine.step;
    if (newStep !== step) {
      history.replace(getPath(newStep, intermediario));
    }
  };

export const back =
  (history: History) =>
  (dispatch: Dispatch, getState: () => IStore): void => {
    const state = getState();
    const step = state.engine.step;
    const intermediario = state.intermediario.id;
    dispatch({ type: EngineActionType.BACK });
    const newStep = getState().engine.step;
    if (newStep !== step) {
      history.replace(getPath(newStep, intermediario));
    }
  };

export const backToStep =
  (step: Step, history: History) =>
  (dispatch: Dispatch, getState: () => IStore): void => {
    const state = getState();
    const prevSteps = state.engine.prevSteps;
    const intermediario = state.intermediario.id;
    if (prevSteps.indexOf(step) !== -1) {
      dispatch({ type: EngineActionType.BACK_TO_STEP, payload: step });
      history.replace(getPath(step, intermediario));
    }
  };
